<template>
  <div :style="styles ? styles : spinnerStyles.wrapper">
    <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6px"  cx="33" cy="33" r="30" />
    </svg>
  </div>
</template>
<script>
export default {
  name: 'spinner',
  props: {
    styles: {}
  },
  data() {
    return {
      spinnerStyles: {
        wrapper: {
          position: 'absolute',
          top: '0',
          right: '0',
          left: '0',
          bottom: '0',
          margin: 'auto',
          display: 'block',
          height: '65px',
          width: '65px'
        }
      }
    };
  }
};
</script>
<style>
.spinner {
  margin: auto;
  animation: rotator 1.4s linear infinite;
}

@keyframes rotator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
}

.path {
  stroke-dasharray: 187px;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite;
}

@keyframes colors {
  0% {
    stroke: #4285f4;
  }
  25% {
    stroke: #de3e35;
  }
  50% {
    stroke: #f7c223;
  }
  75% {
    stroke: #1b9a59;
  }
  100% {
    stroke: #4285f4;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 187;
  }
  50% {
    stroke-dashoffset: 46.75;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 187;
    transform: rotate(450deg);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/general/Spinner.vue